import { FC } from "react";

interface BenefitItemProps {
    benefit: 'benefit-1' | 'benefit-2' | 'benefit-3' | 'benefit-4' | 'benefit-5' | 'benefit-6'
    title: string
}

const BenefitItem: FC<BenefitItemProps> = ({ benefit, title }) => {
    return (
        <>
            <img src={`/assets/icons/benefits/${benefit}.png`} alt={benefit} className="mb-3 mb-md-4 logo" />
            <div className="d-flex justify-content-center">
                <h5 className="desc-benefit">
                    {title}
                </h5>
            </div>
        </>
    )
}

export { BenefitItem };